/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminPrintLabelRequest
 */
export interface AdminPrintLabelRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminPrintLabelRequest
     */
    asin: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPrintLabelRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPrintLabelRequest
     */
    url: string;
}

export function AdminPrintLabelRequestFromJSON(json: any): AdminPrintLabelRequest {
    return AdminPrintLabelRequestFromJSONTyped(json, false);
}

export function AdminPrintLabelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPrintLabelRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asin': json['asin'],
        'description': json['description'],
        'url': json['url'],
    };
}

export function AdminPrintLabelRequestToJSON(value?: AdminPrintLabelRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asin': value.asin,
        'description': value.description,
        'url': value.url,
    };
}

